import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getEquipmentParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'equipmentParts';

export const equipmentPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearEquipmentParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getEquipmentParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearEquipmentParts } = equipmentPartsSlice.actions;

export const equipmentParts = equipmentPartsSlice.reducer;
